import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule, FormControl, Validators } from '@angular/forms';

export type FinalizeDiagnosticReportConfirmDialogData = {
  expectedLastName: string;
  title?: string;
  message?: string;
};

@Component({
  selector: 'app-finalize-diagnostic-report-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './finalize-diagnostic-report-confirm-dialog.component.html',
  styleUrl: './finalize-diagnostic-report-confirm-dialog.component.scss',
})
export class FinalizeDiagnosticReportConfirmDialogComponent {
  lastName = new FormControl<string>('', { nonNullable: true, validators: [Validators.required] });

  readonly data = inject<FinalizeDiagnosticReportConfirmDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<FinalizeDiagnosticReportConfirmDialogComponent>);

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    const value = (this.lastName.value ?? '').toString();
    this.dialogRef.close(value);
  }
}
